import React, { FC } from "react";
import NewModal from "./NewModal";
import { Box } from "../Container";
import { Text } from "../index";
import { Button } from "../Button";
import { theme } from "@ovou-inc/ovou-ui";

const RestirectedModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}> = ({
  isOpen,
  onClose,
  message = "Only the team owner has permission to update the subscription. Please reach out to them if you’d like to make changes.",
}) => {
  return (
    <NewModal
      isOpen={isOpen}
      onClose={onClose}
      title="Team Owner Only"
      modalBody={
        <Box>
          <Text>{message}</Text>
          <Button width="100%" onClick={onClose} mt={4}>
            Got it
          </Button>
        </Box>
      }
      modalHeaderStyle={{
        color: theme.palette.brand.primary.black,
      }}
      size="lg"
    />
  );
};

export default RestirectedModal;
